import { render, staticRenderFns } from "./template-form.vue?vue&type=template&id=3866dcb4"
import script from "./template-form.vue?vue&type=script&lang=js"
export * from "./template-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3866dcb4')) {
      api.createRecord('3866dcb4', component.options)
    } else {
      api.reload('3866dcb4', component.options)
    }
    module.hot.accept("./template-form.vue?vue&type=template&id=3866dcb4", function () {
      api.rerender('3866dcb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Distribution/template-form.vue"
export default component.exports